@if (keywordResearchType === keywordResearchTypes_StrategyUpdate) {
  <button class="btn btn-secondary me-4 btn-sm" type="button" (click)="removePage()" title="Remove Url">
    <i class="fas fa-times fa-no-margin"></i>
  </button>
} @else {
  <button class="btn btn-success me-4 dropdown-toggle" type="button" data-toggle="dropdown"
    [ngClass]="{'btn-success': pageSuggestion.StatusId === websiteUrlStatuses_Target, 'btn-primary': pageSuggestion.StatusId === websiteUrlStatuses_Supporting, 'btn-secondary': pageSuggestion.StatusId === websiteUrlStatuses_New }">
    <ng-container *ngIf="pageSuggestion.StatusId === websiteUrlStatuses_Target">Target</ng-container>
    <ng-container *ngIf="pageSuggestion.StatusId === websiteUrlStatuses_Supporting">Supporting</ng-container>
    <ng-container *ngIf="pageSuggestion.StatusId === websiteUrlStatuses_New">New</ng-container>
  </button>
  <ul class="dropdown-menu" role="menu">
    <ng-container *ngIf="pageSuggestion.StatusId === websiteUrlStatuses_Target">
      <li>
        <button class="btn-link dropdown-item disabled">New</button>
      </li>
      <li>
        <button class="btn-link dropdown-item" (click)="updatePageStatus(websiteUrlStatuses_Supporting)">Supporting</button>
      </li>
      <li>
        <button class="btn-link dropdown-item disabled">Target</button>
      </li>
    </ng-container>
    <ng-container *ngIf="pageSuggestion.StatusId === websiteUrlStatuses_Supporting">
      <li>
        <button class="btn-link dropdown-item disabled">New</button>
      </li>
      <li>
        <button class="btn-link dropdown-item disabled">Supporting</button>
      </li>
      <li>
        <button class="btn-link dropdown-item" (click)="updatePageStatus(websiteUrlStatuses_Target)">Target</button>
      </li>
    </ng-container>
    <ng-container *ngIf="pageSuggestion.StatusId === websiteUrlStatuses_New">
      <li>
        <button class="btn-link dropdown-item disabled">New</button>
      </li>
      <li>
        <button class="btn-link dropdown-item disabled">Supporting</button>
      </li>
      <li>
        <button class="btn-link dropdown-item disabled">Target</button>
      </li>
    </ng-container>
    <div class="dropdown-divider"></div>
    <li>
      <button class="btn-link dropdown-item" (click)="removePage()">Remove</button>
    </li>
  </ul>
}